import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $LogoutButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: ${spacing('xs')};
  color: ${({ theme }) => theme.colors.default};
  opacity: 1;
  transition: opacity ${({ theme }) => theme.interactions.basicTiming};

  &:hover {
    opacity: 0.7;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;
